import { Type, type Static } from "typebox";
import { ProductKeySchema, SuiteIdentityV1Schema } from "./identity.ts";

export const LaunchAuthorizeQueryV1Schema = Type.Object({
  version: Type.Literal(1), product: ProductKeySchema,
  callback_uri: Type.String({ format: "uri" }), return_path: Type.String({ minLength: 1, maxLength: 2048 }),
  state: Type.String({ minLength: 32, maxLength: 256 }),
  code_challenge: Type.String({ pattern: "^[A-Za-z0-9_-]{43}$" }),
}, { additionalProperties: false });
export type LaunchAuthorizeQueryV1 = Static<typeof LaunchAuthorizeQueryV1Schema>;

export const LaunchExchangeRequestV1Schema = Type.Object({
  version: Type.Literal(1), code: Type.String({ minLength: 32, maxLength: 256 }),
  codeVerifier: Type.String({ minLength: 43, maxLength: 128 }),
}, { additionalProperties: false });
export type LaunchExchangeRequestV1 = Static<typeof LaunchExchangeRequestV1Schema>;

export const LaunchExchangeResponseV1Schema = Type.Object({
  version: Type.Literal(1), childToken: Type.String({ minLength: 32, maxLength: 256 }),
  identity: SuiteIdentityV1Schema,
}, { additionalProperties: false });
export type LaunchExchangeResponseV1 = Static<typeof LaunchExchangeResponseV1Schema>;
